<template>
    <div class="service-form-view">
        <b-card v-if="data !== null && data.data !== null">
            <b-table v-if="!data.data.isSerialNoSearchResult" stacked :items="formHeaderData" :fields="formHeaderFields" caption-top>
                <template v-slot:table-caption>{{ data.data.history[0].formId }} Numaralı arıza formu detayları.</template>
                <template v-slot:cell(receiver)="rowData">
                        <span v-html="rowData.item.receiver"></span>
                </template>
            </b-table>

            <div class="shipmentCodeDesc" v-if="!data.data.isSerialNoSearchResult">
                Not: <strong>Kargo Gönderi Kodu</strong>, ürünün çıkış tarihi itibariyle saat <strong>18:00'dan sonra</strong> aktif olacaktır.
            </div>

            <b-table striped hover v-if="!data.data.isSerialNoSearchResult" :items="historyItemData" :fields="historyItemFields" caption-top>
                <template v-slot:table-caption>Arıza formu tarihçesi.</template>
                <template v-slot:cell(historyDate)="rowData">
                    {{rowData.item.historyDate | moment('DD/MM/YYYY')}}
                </template>
                <template v-slot:cell(isToReturn)="rowData">
                    <div v-if="showToReturnFormButton(rowData.item)">
                        <b-button size="sm" @click="rowData.toggleDetails" >
                             İade işlemi <v-icon name="angle-double-right"/>
                        </b-button>
                    </div>

                    <div v-if="showRowDetail(rowData)">
                        <b-button size="sm" @click="rowData.toggleDetails" >
                             Detay <v-icon name="angle-double-right"/>
                        </b-button>
                    </div>

                </template>
                <template v-slot:row-details="rowData">
                    <div v-if="showToReturnFormButton(rowData.item)">
                        <p class="text-danger">
                            Son kullanıcı iseniz; ücret iadesi için, "İade Formu Yazdır" butonuna basıp İade formu çıktısını alarak, aldığınız çıktıyla birlikte ürünü elden servis noktamıza teslim ettiyseniz size teslim edilen servis fişi ile birlikte, satın aldığınız firmaya müracaat ederek ücret iadesi talep edebilirsiniz.
                        </p>
                        <b-button size="sm" @click="printToReturnForm(rowData.item)"><v-icon name="print" /> İade Formunu Yazdır</b-button>
                    </div>
                    <div v-if="showRowDetail(rowData)">
                        <ul class="product-change-details">
                            <li class="pb-2 text-danger"><strong>Ürün Değişimi</strong></li>
                            <li><strong>Yeni Ürün Kodu:</strong> {{rowData.item.code2}}</li>
                            <li><strong>Yeni Seri No:</strong> {{rowData.item.serialNo2}}</li>
                        </ul>
                    </div>
                </template>


            </b-table>

            <b-table striped hover v-if="data.data.isSerialNoSearchResult" :items="historyItemData" :fields="historyItemFields" caption-top >
                <template v-slot:table-caption>İlgili arıza formları.</template>
                <template v-slot:cell(formId)="rowData">
                    <a href="#" @click="searchByFormNo(rowData.item.formId)" class="historyItem">
                        <v-icon name="search" />
                        {{ rowData.item.formId }}
                    </a> 
                </template> 
                <template v-slot:cell(historyDate)="rowData">
                    {{rowData.item.historyDate | moment('DD/MM/YYYY')}}
                </template>
                <template v-slot:cell(isToReturn)="rowData">
                    {{ rowData.item.isToReturn ? '' : '' }}
                </template> 

            </b-table>
        </b-card>
        <b-card v-if="data !== null && !data.success" bg-variant="danger" text-variant="white" class="text-center">
            <b-card-text><v-icon name="exclamation-circle"/> {{ data.message }}</b-card-text>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'ServiceFormView',
    props: {
        data: Object
    },
    methods: {
        searchByFormNo(formNo) {
            this.$emit('SearchByFormNo', { from: 'ServiceFormForm', query: formNo, icon: 'tools', tabIndex: 0 });
        },
        showToReturnFormButton(historyItem){
            if(historyItem.isToReturn && this.data.data.customer.kunnr === '0ARZ100000')
                return (this.data.data.history.indexOf(historyItem) === (this.data.data.history.length - 1));
            return false;
        },
        showRowDetail(rowData)
        {
            if(rowData.item.code2 !== ''){

                switch (rowData.item.status) {
                    case 'init':
                    case 'sup4':
                    case 't_or':
                    case 't_oc':
                    case 'sup3':
                        return true;
                 }
            }
            return false;
        },
        convertDateToString(date)
        {
            var dd = date.getDate();
			var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
			if (dd < 10){
                dd = '0' + dd;
            }
			if (mm < 10){
                mm = '0' + mm;
            }
			return dd + '/' + mm + '/' + yyyy;
        },
        printToReturnForm(rowDataItem)
        {
            var printContent = document.getElementById('printArea').innerHTML;
			printContent = printContent.replace('[{BELGE_TARIHI}]', this.convertDateToString(new Date()));
			printContent = printContent.replace('[{IADE_ONAY_TARIHI}]', this.convertDateToString(new Date(rowDataItem.historyDate)));
			printContent = printContent.replace('[{REFERANS_NO}]', rowDataItem.formId);
			printContent = printContent.replace('[{BELGE_NO}]', rowDataItem.formId);
			printContent = printContent.replace('[{URUN_MODELI}]', rowDataItem.code);
			printContent = printContent.replace('[{SERINO}]', rowDataItem.serialNo);
			printContent = printContent.replace('[{MUSTERI_ADI}]', this.data.data.customer.name1);
			printContent = printContent.replace('[{MUSTERI_TELEFON}]', this.data.data.customer.telf1);
            printContent = printContent.replace('[{ONAY_TARIHI}]', this.convertDateToString(new Date(rowDataItem.historyDate)));
            
            document.getElementById('printArea').innerHTML = printContent;
            window.print();
        }
    },
    computed: {
        formHeaderFields() {
            var result = [
                { key: 'code', label: 'Ürün Kodu' },
                { key: 'serialNo', label: 'Seri Numarası' },
                { key: 'descriptions', label: 'Arıza Açıklaması' },
                { key: 'accessories', label: 'Aksesuarlar' },
                { key: 'sender', label: 'Malı Teslim Eden' },
                { key: 'receiver', label: 'Malı Telim Alan' },
                { key: 'shipmentCode', label: 'Kargo Gönderi Kodu' },
            ];

            if(this.data.data.status.warrantyStatusText !== 'N/A')
                result.push({ key: 'warrantyStatusText', label: 'Garanti Durumu' });

            return result;
        },
        formHeaderData() {

            var result = {
                code: this.data.data.status.code,
                serialNo: this.data.data.status.serialNo,
                receiver: this.data.data.receiver.map(m => m.line).join(', '),
                sender: this.data.data.sender.map(m => m.line).join(', '),
                accessories: this.data.data.accessories.map(m => m.line).join(', '),
                descriptions: this.data.data.descriptions.map(m => m.line).join(', '),
                shipmentCode: '-'
            };

            if(this.data.data.status.shipmentCode != "0") {
                result.shipmentCode = this.data.data.status.shipmentCode
            }

            if(this.data.data.status.warrantyStatusText !== 'N/A')
                result.warrantyStatusText = this.data.data.status.warrantyStatusText;

            return [result];
        },
        historyItemFields() {
            return [
                { key: 'formId', label: 'Belge Numarası' },
                { key: 'historyDate', label: 'Tarih' },
                { key: 'historyTime', label: 'Saat' },
                { key: 'statusText', label: 'Durum' },
                { key: 'isToReturn', label: '' }
            ];
        },
        historyItemData() {
            return this.data.data.history;
        }
    }
}
</script>

<style scoped>
    .shipmentCodeDesc {
        margin-top: -20px;
        padding-left: 12px;
        padding-right: 20px;
        padding-bottom: 10px;
        margin-bottom: 30px;
        border-bottom: 1px solid rgb(222, 226, 230);
        color: rgb(108, 117, 125);
        font-size: 12.8px;
    }
    ul.product-change-details
    {
        list-style: none;
        padding: 0;
        margin: 0 0 20px 0;
        border: 1px solid #6c757d;
        padding: 15px;;
    }
    ul.product-change-details li 
    {

    }
</style>